import { addOrUpdateArrayItem } from "services/utils";
const attachmentProgress = {
  state: {
    isLoading: false,
    attachmentDownloads: [],
    overallProgress: 0,
  },
  reducers: {
    loadStart: (state) => {
      return {
        ...state,
        isLoading: true,
      };
    },
    loadStop: (state) => {
      return {
        ...state,
        isLoading: false,
      };
    },
    addAttachmentDownload: (state, newUpload, loaded) => {
      const { id, name, size } = newUpload;
      const totalDownloaded = ((loaded * 100) / size || 0).toFixed();
      const isLoading = totalDownloaded === "100" ? false : true;
      const downloadItem = {
        id: id,
        size: size || 0,
        name: name,
        totalDownloaded: totalDownloaded.toString() || 0,
        isLoading: isLoading,
      };
      const downloadsArray = addOrUpdateArrayItem(
        state.attachmentDownloads,
        (item) => item.id === id,
        downloadItem
      );
      const checkForCompletion =
        downloadsArray && downloadsArray.map((download) => download.totalDownloaded);
      const sumDownloadsProgress =
        checkForCompletion &&
        checkForCompletion.reduce(
          (previousValue, currentValue) => parseInt(previousValue) + parseInt(currentValue),
          0
        );
      const overallProgress = () => (sumDownloadsProgress / downloadsArray.length).toFixed();
      return {
        ...state,
        attachmentDownloads: downloadsArray,
        overallProgress: overallProgress(),
      };
    },
    resetAttachmentState: (state) => {
      return {
        ...state,
        isLoading: false,
        attachmentDownloads: [],
        overallProgress: 0,
      };
    },
  },
};
export default attachmentProgress;
